import { c as _c } from "react/compiler-runtime";
import { FileText, HeartHandshake, Info, Mail } from "lucide-react";
import Link from "next/link";
import { PATH_ABOUT, PATH_DASHBOARD, PATH_PAGE } from "~/routes/paths";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "~/shadcn/ui/accordion";
import { Button } from "~/shadcn/ui/button";
import Logo from "../logo";
import { Card } from "../ui/card";
import { SheetClose } from "../ui/sheet";
type Props = {
  dict: Dictionary;
  lang: AppLocale;
};
export function HomeSidebarContent(t0) {
  const $ = _c(69);
  const {
    dict,
    lang
  } = t0;
  let t1;
  if ($[0] !== lang) {
    t1 = PATH_PAGE.home(lang);
    $[0] = lang;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Logo disabledLink={true} className="w-10 h-10" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Card className="flex flex-row items-center px-4 py-4 border-none gap-4 mx-[-16px] shadow-md rounded-lg">{t2}<div className="flex flex-col text-center font-light text-sm"><span className="leading-tight">Stiftelsen</span><span className="leading-tight">Kempe-Carlgrenska</span><span className="leading-tight">Fonden</span></div></Card>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <Link href={t1}>{t3}</Link>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Info />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== lang) {
    t6 = PATH_PAGE.about(lang);
    $[7] = lang;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = dict["Om oss"];
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <div className="flex gap-4 items-center  rounded-md px-4 mx-[-16px]">{t5}<SheetClose asChild={true}><Button asChild={true} variant="ghost" className="w-full justify-start"><Link href={t6}>{t7}</Link></Button></SheetClose></div>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <HeartHandshake />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = dict["V\xE5ra anslag"];
  let t11;
  if ($[13] !== t10) {
    t11 = <AccordionTrigger className="hover:no-underline  rounded-md px-4 py-2 mx-[-16px]"><div className="flex gap-7 items-center ">{t9}{t10}</div></AccordionTrigger>;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== lang) {
    t12 = PATH_ABOUT.students(lang);
    $[15] = lang;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = dict["Musikstuderande p\xE5 h\xF6gskoleniv\xE5"];
  let t14;
  if ($[17] !== t12 || $[18] !== t13) {
    t14 = <li><SheetClose asChild={true}><Button asChild={true} variant="ghost" className="w-full justify-start py-2"><Link href={t12}>{t13}</Link></Button></SheetClose></li>;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== lang) {
    t15 = PATH_ABOUT.education(lang);
    $[20] = lang;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== dict.Utbildning || $[23] !== t15) {
    t16 = <li><SheetClose asChild={true}><Button asChild={true} variant="ghost" className="w-full justify-start py-2"><Link href={t15}>{dict.Utbildning}</Link></Button></SheetClose></li>;
    $[22] = dict.Utbildning;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== lang) {
    t17 = PATH_ABOUT.childcare(lang);
    $[25] = lang;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  const t18 = dict["Barn med s\xE4rskilda behov"];
  let t19;
  if ($[27] !== t17 || $[28] !== t18) {
    t19 = <li><SheetClose asChild={true}><Button asChild={true} variant="ghost" className="w-full justify-start py-2"><Link href={t17}>{t18}</Link></Button></SheetClose></li>;
    $[27] = t17;
    $[28] = t18;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== lang) {
    t20 = PATH_ABOUT.integration(lang);
    $[30] = lang;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] !== dict.Integrationsarbete || $[33] !== t20) {
    t21 = <li><SheetClose asChild={true}><Button asChild={true} variant="ghost" className="w-full justify-start py-2"><Link href={t20}>{dict.Integrationsarbete}</Link></Button></SheetClose></li>;
    $[32] = dict.Integrationsarbete;
    $[33] = t20;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== lang) {
    t22 = PATH_ABOUT.research(lang);
    $[35] = lang;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== dict.Forskare || $[38] !== t22) {
    t23 = <li><SheetClose asChild={true}><Button asChild={true} variant="ghost" className="w-full justify-start py-2"><Link href={t22}>{dict.Forskare}</Link></Button></SheetClose></li>;
    $[37] = dict.Forskare;
    $[38] = t22;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] !== t14 || $[41] !== t16 || $[42] !== t19 || $[43] !== t21 || $[44] !== t23) {
    t24 = <AccordionContent><ul className="list-disc ml-6">{t14}{t16}{t19}{t21}{t23}</ul></AccordionContent>;
    $[40] = t14;
    $[41] = t16;
    $[42] = t19;
    $[43] = t21;
    $[44] = t23;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t11 || $[47] !== t24) {
    t25 = <Accordion type="multiple"><AccordionItem value="about" className="border-none">{t11}{t24}</AccordionItem></Accordion>;
    $[46] = t11;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <FileText />;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== lang) {
    t27 = PATH_DASHBOARD.applications.root(lang);
    $[50] = lang;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== dict.Ansökningar || $[53] !== t27) {
    t28 = <div className="flex gap-4 items-center  rounded-md px-4 mx-[-16px]">{t26}<SheetClose asChild={true}><Button asChild={true} variant="ghost" className="w-full justify-start"><Link href={t27}>{dict.Ansökningar}</Link></Button></SheetClose></div>;
    $[52] = dict.Ansökningar;
    $[53] = t27;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Mail />;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== lang) {
    t30 = PATH_PAGE.contact(lang);
    $[56] = lang;
    $[57] = t30;
  } else {
    t30 = $[57];
  }
  let t31;
  if ($[58] !== dict.Kontakt || $[59] !== t30) {
    t31 = <div className="flex gap-4 items-center  rounded-md px-4 mx-[-16px]">{t29}<SheetClose asChild={true}><Button asChild={true} variant="ghost" className="w-full justify-start"><Link href={t30}>{dict.Kontakt}</Link></Button></SheetClose></div>;
    $[58] = dict.Kontakt;
    $[59] = t30;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== t25 || $[62] !== t28 || $[63] !== t31 || $[64] !== t8) {
    t32 = <nav className="flex flex-col gap-4 text-sm text-muted-foreground">{t8}{t25}{t28}{t31}</nav>;
    $[61] = t25;
    $[62] = t28;
    $[63] = t31;
    $[64] = t8;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  let t33;
  if ($[66] !== t32 || $[67] !== t4) {
    t33 = <div className="flex flex-col w-full gap-8 py-6">{t4}{t32}</div>;
    $[66] = t32;
    $[67] = t4;
    $[68] = t33;
  } else {
    t33 = $[68];
  }
  return t33;
}